import React from 'react';
import { useStateValue } from '../../store/store';
import { Progress } from '../../ui/style';

const ProgressBar = () => {
    const [{ currentIndex, stepsLength }] = useStateValue();
    let width = (100 / parseFloat(stepsLength)) * (parseFloat(currentIndex) + 1);
    return (
        <>
            <span className="ist-progress-wrap">
                <span className="ist-progress">
                    <span className="current-progress" style={{ width: `${width}%` }}></span>
                </span>
            </span>
        </>
    )

}

export default ProgressBar;
